module.exports = __webpack_public_path__ + "static/media/ER-RUS1_1ohNTLHoppzt0PVq2rMK6dnDlknjwMwht.bc423299.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photos/ER-RUS1_1ohNTLHoppzt0PVq2rMK6dnDlknjwMwht
// module id = 661
// module chunks = 0